export default __webpack_public_path__ + "media/images/images_v2/onglet-dafb646b772bca6edeb3b3334535f7c5.png";